import { _ } from "../../../../../core/polyglot/polyglot.js";
import { formatAsLongMonthAndYear } from "../../../../../core/helpers/date-formatting-util.js";
import { spacer, stacker } from "../../../../../core/elements/index.js";
import AbstractForecastFiscalYearCardRenderingStrategy from "./AbstractForecastFiscalYearCardRenderingStrategy.js";

/**
 * RenderingStrategy to render the ForecastFiscalYearCard for the Cash Flow report tab.
 * This renders information, i.e. the value and the period, about the low point, a.k.a. the smallest value,
 * of the current fiscal year.
 */
export default class CashFlowForecastFiscalYearCardRenderingStrategy extends AbstractForecastFiscalYearCardRenderingStrategy {
	constructor() {
		super(...arguments);

		this._lowPointPeriod = undefined;
		this._lowPointValue = undefined;
	}

	renderContentAsBigCardOn(html) {
		html.div(
			{
				"data-test": "ForecastFiscalYearCard",
				class: this._cssClass(),
			},
			spacer(
				{
					direction: "vertical",
					class: "lowPoint",
				},
				html.div(
					{ class: "total" },
					this._renderTitleOn.bind(this),
					this._renderValueOn.bind(this),
				),
				this._renderPeriodOn.bind(this),
			),
		);
	}

	renderContentAsOneLinerOn(html) {
		stacker(
			{
				renderOn: html,
				dataTest: "ForecastFiscalYearCard",
				class: [this._cssClass(), "one-liner"],
				spacing: "between",
			},
			html.div(
				this._renderTitleOn.bind(this),
				this._renderPeriodOn.bind(this),
			),
			stacker({ isBlock: true }, this._renderValueOn.bind(this)),
		);
	}

	setValues({ lowPointPeriod, lowPointValue }) {
		super.setValues(...arguments);

		this._lowPointPeriod = lowPointPeriod;
		this._lowPointValue = lowPointValue;
	}

	_renderTitleOn(html) {
		html.div(
			{ "data-test": "title", class: "title" },
			_("Predicted cash low point"),
		);
	}

	_renderValueOn(html) {
		html.strong(
			{ "data-test": "value", class: "value" },
			this._valueRenderer({
				value: this._lowPointValue,
				size: 6,
			}),
		);
	}

	_renderPeriodOn(html) {
		html.div(
			{ "data-test": "period", class: "footer" },
			formatAsLongMonthAndYear(this._lowPointPeriod?.getStart()),
		);
	}

	_getValue() {
		return this._lowPointValue;
	}
}
